import React from "react";

// Catches render errors anywhere in its subtree so a single broken page can't
// blank the entire admin shell. Logs to the console for debugging.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("[ErrorBoundary] caught", error, info?.componentStack);
  }

  reset = () => this.setState({ error: null });

  render() {
    if (!this.state.error) return this.props.children;

    const message = this.state.error?.message || String(this.state.error);
    return (
      <div
        role="alert"
        style={{
          padding: 24,
          margin: 24,
          border: "1px solid #f44336",
          borderRadius: 8,
          background: "#fff5f5",
          color: "#7a0000",
          fontFamily: "system-ui, sans-serif",
        }}
      >
        <h2 style={{ marginTop: 0 }}>Something went wrong.</h2>
        <p style={{ whiteSpace: "pre-wrap" }}>{message}</p>
        <button
          type="button"
          onClick={this.reset}
          style={{
            padding: "6px 12px",
            border: "1px solid #7a0000",
            background: "white",
            color: "#7a0000",
            cursor: "pointer",
            borderRadius: 4,
          }}
        >
          Try again
        </button>
      </div>
    );
  }
}
